export function scrollTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

export function scrollIntoView(selector) {
    if (!selector) {
        return false;
    }

    const element = document.querySelector(selector);
    if (!element) {
        return false;
    }

    element.scrollIntoView({
        behavior: 'smooth', 
        block: 'center', 
        inline: 'center'
    });

    return true;
}